import { format } from 'date-fns';

export function getFormattedDate(date: string, formatType?: string): string {
  if (!date) {
    return '';
  }
  if (formatType) {
    return format(new Date(date), formatType);
  }
  return format(new Date(date), 'MMM dd, yyy');
}
